<template>
  <div class="pivot-wrapper">
    <div v-if="isMobile && internalPivotConfig" class="global-filter">
      <div class="global-filter-container">
        <div class="icons">
          <div
            v-tooltip="$t('tooltip_edit_' + component)"
            class="icon edit black-fill"
            @click="$emit('toggle-edit')"
          />
          <div
            v-if="hasChanged"
            class="icon refresh"
            :class="!hasChanged ? 'disabled' : 'white-fill'"
            @click="resetToDefault"
          />
          <div class="copy-wrapper white-bckgrd" @click="() => toggleMobileMoreInfo(true)">
            <div class="options-button-icon" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="internalPivotConfig" class="pivot-component">
      <!-- {{ userDimensions }} -->
      <!-- (PivotTable)MODE:{{ mode }} -->
      <!-- {{ expandedDimensionsConfig }} -->
      <!-- <div class="debug">
        <div v-for="dim in pivotConfig.dimensions" :key="dim.id" class="debug-dim">{{ dim }}</div>
      </div> -->
      <div class="left" :class="`left-${component}`">
        <div v-if="userDimensions" class="top">
          <pivot-config-group
            v-if="component === 'map'"
            v-model="internalPivotConfig"
            :options="flatDimensionsOptions"
            :metas="dimensionMetas"
            role="types"
            :component="component"
            mode="quick"
            class="types"
          />
          <pivot-config-group
            v-model="internalPivotConfig"
            :options="flatDimensionsOptions"
            :metas="dimensionMetas"
            role="filters"
            :component="component"
            mode="quick"
          />
          <SmallTimeSlider
            v-if="component === 'map' || component === 'chart'"
            v-model="internalPivotConfig"
            :dimension-metas="dimensionMetas"
            :options="flatDimensionsOptions"
          />
          <div v-if="!isMobile" class="global-filter">
            <div class="global-filter-hack" />
            <div class="global-filter-container">
              <div v-if="currentSearchCount && totalSearchCount" class="search-count-container">
                <div class="search-count-icon" />
                <div class="search-count-text">
                  {{ currentSearchCount + $t('rows_of') + totalSearchCount }}
                </div>
              </div>
              <div v-if="component === 'table'" class="input-wrapper">
                <input v-model="gloablFilterValue">
                <div class="search-button-icon" />
                <div class="close-button-icon" @click="resetSearch" />
              </div>
              <div class="icons">
                <div
                  v-tooltip="$t('tooltip_edit_' + component)"
                  class="icon edit black-fill"
                  @click="$emit('toggle-edit')"
                />
                <div
                  v-if="hasChanged"
                  v-tooltip="hasChanged && $t('table_reset')"
                  class="icon refresh"
                  :class="!hasChanged ? 'disabled' : 'white-fill'"
                  @click="resetToDefault"
                />
              </div>
              <div v-tooltip="$t('more_op')" class="copy-wrapper" @click="toggleMoreOp">
                <div class="options-button-icon" />
                <div v-if="moreOpOpen" class="absolute-wrap">
                  <div v-if="component === 'table'" class="op-wrap" @click="copyTableToClipboard">
                    <div class="icon-copy" />
                    <span>{{ $t('copy') }}</span>
                  </div>
                  <div class="op-wrap" @click="exportFileFunc">
                    <div class="icon-download" />
                    <span>{{ $t('download') }}</span>
                  </div>
                  <div class="op-wrap" @click="showShareModal">
                    <div class="icon-share" />
                    <span>{{ $t('share') }}</span>
                  </div>
                  <div class="op-wrap" @click="modalOpenApi">
                    <div class="icon-api" />
                    <span>{{ $t('data_api') }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="component !== 'table' && isLogged"
                class="fav-button"
                :class="favChecked && 'fav-checked'"
                @click="toggleFavCheck"
              >
                <div v-if="dataLoading" class="icon-loader" />
                <span v-else>{{ $t(favChecked ? (!overwrite ? 'saved' : 'overwrite') : 'save') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom" :class="component + '-container'">
          <template v-if="tableData && component === 'table'">
            <div
              v-if="(currentSearchCount && totalSearchCount && isMobile) || (component === 'table' && isMobile)"
              class="top"
            >
              <div v-if="currentSearchCount && totalSearchCount" class="search-count-container">
                <div class="search-count-icon" />
                <div class="search-count-text">
                  {{ currentSearchCount + $t('rows_of') + totalSearchCount }}
                </div>
              </div>
              <div v-if="component === 'table'" class="input-wrapper">
                <input v-model="gloablFilterValue">
                <div class="search-button-icon" />
              </div>
            </div>
            <Table
              ref="table"
              :data="tableData"
              :pivot-config="pivotConfig"
              :can-drill-down="canDrillDown"
              :global-filter="gloablFilterValue"
              :data-card="dataCard"
              @change-search="
                (val, total) => {
                  $emit('change-search-count', val, total)
                }
              "
              @change-col-config="e => (tableInternalConfig = e)"
              @drill-down="drillDown"
              @dblclick="onCellDblclick"
            />
          </template>
          <template v-else-if="tableData && component === 'chart'">
            <SDVChart
              ref="chart"
              :data="tableData"
              :all-time-values="allTimeValues"
              :chart-type="chartType"
              :chart-config="internalChartConfig"
              :pivot-config="internalPivotConfig"
              :tooltip-function="tooltipFunction"
              :dimension-metas="dimensionMetas"
              :data-card="dataCard"
              :lite="isMobile"
              :options="flatDimensionsOptions"
              @change-chart-config="value => (internalChartConfig = value)"
              @change-pivot-config="value => (internalPivotConfig = value)"
            />
          </template>
          <template v-else-if="tableData && component === 'map'">
            <Map
              ref="chart"
              :data="tableData"
              :map-config="internalMapConfig"
              :pivot-config="internalPivotConfig"
              :tooltip-function="tooltipFunction"
              :dimension-metas="dimensionMetas"
              :data-card="dataCard"
              :options="flatDimensionsOptions"
              :all-time-values="allTimeValues"
              @change-map-config="value => (internalMapConfig = value)"
            />
          </template>
          <div v-if="needsSetup" class="table-overlay cover">
            <div class="content">{{ $t('configure_your_table') }}</div>
          </div>
          <div v-else-if="status === 'calculating'" class="table-overlay">
            <div class="content"><Loader :text="$t('calculating')" /></div>
          </div>
          <div v-else-if="status === 'loading'" class="table-overlay">
            <div class="content"><Loader :text="$t('loading')" /></div>
          </div>
        </div>
      </div>
      <div
        v-if="userDimensions && moreFiltersVisible && tableEditOpen && !isMobile"
        class="right full-filters"
      >
        <div class="full-filters-header">
          <div class="full-filters-title">
            {{
              component === 'chart'
                ? $t('tooltip_edit_chart')
                : component === 'map'
                  ? $t('tooltip_edit_map')
                  : $t('tooltip_edit_table')
            }}
          </div>
          <div class="full-filters-close-icon" @click="$emit('toggle-edit')" />
        </div>
        <div
          v-if="component === 'chart' || (component === 'map' && !HIDE_MAP_PIVOT_CONFIG)"
          class="config-tabs"
        >
          <div
            class="config-tab"
            :class="{ active: currentConfig === 'pivot' }"
            @click="currentConfig = 'pivot'"
          >
            {{ $t('data_config') }}
          </div>
          <div
            :class="{ active: currentConfig === 'chart' }"
            class="config-tab"
            @click="currentConfig = 'chart'"
          >
            {{ $t('chart_config') }}
          </div>
        </div>
        <template v-if="currentConfig === 'pivot'">
          <template v-if="component === 'table' || component === 'map'">
            <table-pivot-config
              v-model="internalPivotConfig"
              :flat-dimensions-options="flatDimensionsOptions"
              :dimension-metas="dimensionMetas"
            />
          </template>
          <template v-else-if="component === 'chart'">
            <chart-pivot-config
              v-model="internalPivotConfig"
              :flat-dimensions-options="flatDimensionsOptions"
              :dimension-metas="dimensionMetas"
              :chart-type="chartType"
            />
          </template>
        </template>
        <template v-else-if="currentConfig === 'chart'">
          <chart-config
            v-if="component === 'chart'"
            v-model="internalChartConfig"
            :chart-id="currentChart.id"
            :all-time-values="allTimeValues"
          />
          <map-config v-else v-model="internalMapConfig" :all-time-values="allTimeValues" />
        </template>
      </div>
      <GrowUpMenu
        v-else-if="userDimensions && moreFiltersVisible && isMobile"
        :mobile-filters-open="tableEditOpen"
        :clean-filters="resetToDefault"
        :title-menu="component === 'chart' ? $t('tooltip_edit_chart') : $t('tooltip_edit_table')"
        @toggle-mobile-filter="$emit('toggle-edit')"
      >
        <template v-slot:menu-options>
          <div v-if="component === 'chart'" class="config-tabs">
            <div
              class="config-tab"
              :class="{ active: currentConfig === 'pivot' }"
              @click="currentConfig = 'pivot'"
            >
              {{ $t('data_config') }}
            </div>
            <div
              :class="{ active: currentConfig === 'chart' }"
              class="config-tab"
              @click="currentConfig = 'chart'"
            >
              {{ $t('chart_config') }}
            </div>
          </div>
          <template v-if="currentConfig === 'pivot'">
            <template v-if="component === 'table'">
              <table-pivot-config
                v-model="internalPivotConfig"
                :flat-dimensions-options="flatDimensionsOptions"
                :dimension-metas="dimensionMetas"
              />
            </template>
            <template v-else>
              <chart-pivot-config
                v-model="internalPivotConfig"
                :flat-dimensions-options="flatDimensionsOptions"
                :dimension-metas="dimensionMetas"
                :chart-type="chartType"
              />
            </template>
          </template>
          <template v-else-if="currentConfig === 'chart'">
            <chart-config
              v-if="component === 'chart'"
              v-model="internalChartConfig"
              :chart-id="currentChart.id"
              :all-time-values="allTimeValues"
            />
            <map-config v-else v-model="internalMapConfig" :all-time-values="allTimeValues" />
          </template>
        </template>
      </GrowUpMenu>
      <GrowUpMenu
        v-if="isMobile"
        :mobile-filters-open="mobileMoreInfoOpen"
        :title-menu="$t('add_more_info')"
        :show-fixed-buttons="false"
        @toggle-mobile-filter="toggleMobileMoreInfo"
      >
        <template v-slot:menu-options>
          <div class="more-info-container">
            <div class="note-container">
              <span v-if="dataCard.data[0].measureUnit" class="note-text">{{
                $t('used_unit') + dataCard.data[0].measureUnit
              }}</span>
            </div>
            <div
              v-if="component === 'table'"
              class="mobile-button-wrapper"
              @click="copyTableToClipboard"
            >
              <div class="icon-copy" />
              <span>{{ $t('copy') }}</span>
            </div>
            <div
              v-if="isLogged && component !== 'table'"
              class="mobile-button-wrapper"
              :class="favChecked && 'fav-color'"
              @click="toggleFavCheck"
            >
              <div class="icon favourite" />
              <span>{{ $t(favChecked ? 'saved' : 'save') }}</span>
              <div v-if="dataLoading" class="icon-loader" />
            </div>
            <div class="mobile-button-wrapper" @click="exportFileFunc">
              <div class="icon download" />
              <span>{{ $t('download') }}</span>
            </div>
            <div class="mobile-button-wrapper" @click="showShareModal">
              <div class="icon share" />
              <span>{{ $t('share') }}</span>
            </div>
            <div class="mobile-button-wrapper" @click="modalOpenApi">
              <div class="icon-api" />
              <span>{{ $t('data_api') }}</span>
            </div>
          </div>
        </template>
      </GrowUpMenu>
      <modal
        name="modal-statistics-api"
        :width="isMobile ? '90%' : '60%'"
        :height="isMobile ? '80%' : '70%'"
        :style="isMobile ? 'marginTop: 5%' : 'marginTop: 0'"
      >
        <ModalStatisticsApi :modal-close="modalCloseApi" />
      </modal>
    </div>
  </div>
</template>

<script>
import { buildPivotTable, getAllTimeValues } from '@/utils/dataUtils'
import { flattenDimensions, userDimensions } from '@/utils/dimensionUtils'
import Table from '@/components/table/Table.vue'
import GrowUpMenu from '../mobile/GrowUpMenu.vue'
import PivotConfigGroup from './PivotConfigGroup.vue'
import TablePivotConfig from './TablePivotConfig.vue'
import ChartPivotConfig from './ChartPivotConfig.vue'
import SmallTimeSlider from '@/components/charts/SmallTimeSlider'
import Loader from '../Loader.vue'
import { coordsEqual } from '@/utils/reportUtils'
import SDVChart from '@/components/charts/SDVChart'
import Map from '@/components/maps/Map'
import ChartConfig from '@/components/charts/ChartConfig'
import MapConfig from '@/components/maps/MapConfig'
import { exportFile } from '@/utils/exportUtils'
//import { downloadStatisticsFile } from '@/services/api'
import { sdvTooltipFunction } from '@/utils/chart'
import { deleteUserFav, editUserFav, createUserFav } from '@/services/user-api'
import { filtersToString, stringToFilters, getDiffs, applyDiffs } from '@/utils/filterUtils'
import { createDefaultPivotConfig } from '@/utils/dimensionUtils.js'
import { debounce } from 'debounce'
import ModalStatisticsApi from '../modals/ModalStatisticsApi.vue'

const LIVE_QUERY_CONFIG = false
export default {
  components: {
    Table,
    GrowUpMenu,
    SDVChart,
    ChartConfig,
    MapConfig,
    PivotConfigGroup,
    TablePivotConfig,
    ChartPivotConfig,
    SmallTimeSlider,
    Loader,
    Map,
    ModalStatisticsApi,
  },
  model: {
    prop: 'pivotConfig',
    event: 'change-config',
  },
  props: {
    tableEditOpen: {
      type: Boolean,
    },
    pivotConfig: {
      type: Object,
    },
    // defaultPivotConfig: {
    //   type: Object,
    // },
    data: {},
    dimensions: {},
    dataCard: {},
    mode: {
      type: String,
      default: 'consume',
      validator: function (value) {
        return ['consume', 'edit'].includes(value)
      },
    },
    component: {
      type: String,
      default: 'table',
    },
    currentChart: {
      type: Object,
      default: null,
    },
    currentSearchCount: {
      type: Number,
    },
    totalSearchCount: {
      type: Number,
    },
  },
  data() {
    return {
      mobileMoreInfoOpen: false,
      moreOpOpen: false,
      HIDE_MAP_PIVOT_CONFIG: true, //only for testing pivotConfigs with the map
      moreFiltersVisible: this.mode === 'edit',
      currentConfig: this.component === 'map' ? 'chart' : 'pivot',
      // eslint-disable-next-line
      _internalPivotConfig: null, //JSON.parse(JSON.stringify(this.pivotConfig)),
      internalChartConfig: null,
      internalMapConfig: null,
      gloablFilterValue: null,
      status: 'loading',
      mobileFiltersOpen: false,
      tableInternalConfig: null,
      defaultPivotConfig: null,
      dataLoading: false,
      //favorites checkbox
      // favId: null,
      overwrite: false,
    }
  },
  computed: {
    // overwrite() {
    //   let { diffStr, ccfgStr } = this.getConfigQuery()
    //   if (
    //       (diffStr && diffStr !== this.$route.query.diff)
    //        || (ccfgStr && ccfgStr !== this.$route.query.ccfg)
    //     ) {
    //       return true
    //   } else return false
    // },
    isLogged() {
      return this.$store.state.user.isLogged
    },
    favId() {
      if (this.currentChart && this.dataCard.data[0].favourites.length > 0) {
        let found = this.dataCard.data[0].favourites.find(d => {
          let view = d.payload?.match(/view=([^&#]*)/)[1]
          let chart = view === 'chart' && d.payload?.match(/chart=([^&#]*)/)[1]
          return (
            (view === 'map' && this.currentChart.id === 'map') || chart === this.currentChart.id
          )
        })
        return found
      } else return undefined
    },
    favChecked: {
      get() {
        return this.favId?.favouriteId !== undefined
        // let fav = false
        //   this.dataCard.data[0].favourites.forEach(el => {
        //     if (el.payload) {
        //       let payloadTypePart = el.payload.split('%26')[1]
        //       let payloadType = payloadTypePart.split('=')[1]
        //       if (payloadType === this.currentChart.id) {
        //         fav = true
        //       }
        //     }
        //   })
        // }
        // return fav
      },
      set() {
        this.toggleFavCheck()
      },
    },
    internalPivotConfig: {
      get() {
        return this.pivotConfig
      },
      set(v) {
        this._internalPivotConfig = v
        this.queueChangeEvent()
      },
    },
    raw() {
      return this.data
    },
    rawDimensions() {
      return this.dimensions
    },
    hasChanged() {
      // console.log('internalPivotConfig', this.internalPivotConfig)
      let internalChanged =
        this.tableInternalConfig &&
        (this.tableInternalConfig.filters || this.tableInternalConfig.currentSort)
      let pivotConfigChanged =
        JSON.stringify(this.internalPivotConfig) !== JSON.stringify(this.defaultPivotConfig)
      return pivotConfigChanged || internalChanged
    },
    needsSetup() {
      if (!this.pivotConfig) return true
      let needsRows = this.pivotConfig.dimensions.filter(d => d.role === 'rows').length === 0
      let needsCols = this.pivotConfig.dimensions.filter(d => d.role === 'columns').length === 0
      if (this.component === 'table') {
        return needsRows && needsCols ? { needsRows, needsCols } : false
      } else {
        return needsRows ? { needsRows, needsCols } : false
      }
    },
    tableData() {
      let data =
        this.raw && this.pivotConfig && this.flatDimensionsOptions
          ? buildPivotTable(
              this.raw,
              this.pivotConfig,
              this.flatDimensionsOptions,
              this.dimensionMetas,
              this.dataCard?.data[0]?.unit
            )
          : null
      return data ? data : null
    },
    allTimeValues() {
      return getAllTimeValues(
        this.raw,
        this.pivotConfig,
        this.flatDimensionsOptions,
        this.dimensionMetas
      )
    },
    canDrillDown() {
      return false
    },
    chartType() {
      return this.currentChart?.id
    },
  },
  watch: {
    dataCard() {
      let favs = this.dataCard.data[0].favourites
      let fav = favs.find(el => el.payload && window.location.search !== '' && el.payload.indexOf(window.location.search.substring(1, window.location.search.length)) !== -1)
      if (fav) {
        if(window.location.search.substring(1, window.location.search.length) !== fav.payload) {
          let langSource = null
          if (this.$store.state.i18n.lang === 'ca') langSource = 'estad%C3%ADstiques'
          else if (this.$store.state.i18n.lang === 'es') langSource = 'estad%C3%ADsticas'
          else if (this.$store.state.i18n.lang === 'en') langSource = 'statistics'
          this.$router.push('/' + this.$store.state.i18n.lang + '/' + langSource + '/' + this.dataCard.data[0].id + '?' + fav.payload)
        }
      }
      this.dataLoading = false
    },
    data: {
      handler() {
        if(!this.$route.query.diff) this.setDefaultConfigs()
      },
      immediate: true,
    },
    chartType: {
      handler() {
        // evidente, no?
        this.defaultPivotConfig = null
        this.internalChartConfig = null
        this.setDefaultConfigs()
      },
      immediate: false,
    },
    
    // favChecked() {
    //   if (this.dataCard.data[0].favourites.length > 0) {
    //     this.dataCard.data[0].favourites.forEach(el => {
    //       if (el.payload) {
    //         let payloadTypePart = el.payload.split('%26')[1]
    //         let payloadType = payloadTypePart.split('=')[1]
    //         if (payloadType === this.currentChart) {
    //           this.favId = el.favouriteId
    //         }
    //       }
    //     })
    //   }
    // },
    // internalPivotConfig: {
    //   handler(v) {
    //     if (JSON.stringify(this.internalPivotConfig) !== JSON.stringify(this.pivotConfig)) {
    //       this.queueChangeEvent()
    //     }
    //   },
    //   deep: true,
    // },
    pivotConfig: {
      handler() {
        // let clone = JSON.parse(JSON.stringify(value))
        // this.internalPivotConfig = clone
        this.status = 'ready'
        // if (!prev) this.queueChangeEvent()
      },
      immediate: true,
    },
    '$route.query': {
      handler(q) {
        this.onQueryChange(q)
      },
      immediate: true,
    },
    mode() {
      this.moreFiltersVisible = this.mode === 'edit'
    },
  },
  mounted() {
    console.log('PivotTable mounted')
  },

  asyncComputed: {
    // raw() {
    //   return (
    //     this.dimensionOptions &&
    //     getTableData(clientConfigToServerConfig(this.pivotConfig, this.dimensionOptions))
    //   )
    // },
    // rawDimensions() {
    //   return getDimensionsData().then(response => {
    //     return response
    //   })
    // },
    dimensionOptions() {
      return this.rawDimensions && this.rawDimensions.dimensionOptions
    },
    dimensionMetas() {
      return this.rawDimensions && this.rawDimensions.dimensionMetas
    },
    flatDimensionsOptions() {
      return this.rawDimensions && flattenDimensions(this.rawDimensions).dimensionOptions
    },
    userDimensions() {
      return this.rawDimensions && userDimensions(this.rawDimensions).dimensionOptions
    },
  },
  methods: {
    resetSearch() {
      this.gloablFilterValue = ''
    },
    toggleFavCheck() {
      if (!this.dataLoading) {
        this.dataLoading = true
        if (this.favChecked) {
          if (this.overwrite) {
            console.log('overwrite')
            let payload = this.getShareUrl()
            payload = payload.slice(payload.indexOf('?') + 1)
            editUserFav(this.favId.favouriteId, payload, this.favId.enabled).then(() => {
              this.$emit('reload-data-card')
            })
          } else {
            deleteUserFav(this.favId.favouriteId).then(() => {
              this.$emit('reload-data-card')
            })
          }
        } else {
          let payload = this.getShareUrl()
          payload = payload.slice(payload.indexOf('?') + 1)
          createUserFav(this.$route.params.cardId, payload).then(() => {
            this.$emit('reload-data-card')
          })
        }
      }
    },
    /**
     * Toggle mobile more info
     * @public This is a public method
     * @param {Boolean} val value that wants to set
     */
    toggleMobileMoreInfo(val) {
      this.mobileMoreInfoOpen = val ? val : !this.mobileMoreInfoOpen
    },
    toggleMoreOp() {
      this.moreOpOpen = !this.moreOpOpen
    },
    copyTableToClipboard() {
      let transTable = ''
      //header
      this.tableData.header.forEach(lvl => {
        let newLine = true
        lvl.forEach(hed => {
          if (newLine && transTable !== '') {
            transTable += '\n'
            newLine = false
          } else if (!newLine && !hed.isEmptyCol) transTable += '	'
          else newLine = false
          if (hed.colSpan > 1) {
            for (let i = 1; i < hed.colSpan; i++) {
              transTable += hed.label + '	'
            }
            transTable += hed.label
          } else if (!hed.isEmptyCol) {
            transTable += hed.label
          }
        })
      })
      let arrayEmptyCols = this.tableData.header[this.tableData.header.length - 1].map(
        el => el.isEmptyCol
      )
      //rows
      this.tableData.values.forEach(row => {
        let newLine = true
        transTable += '\n'
        row.forEach((el, ind) => {
          if (!arrayEmptyCols[ind]) {
            if (!newLine) transTable += '	'
            else newLine = false
            transTable += el ? (el.label ? el.label : (el.value ? (Number.isInteger(el.value) ? el.value : el.value.toFixed(2)) : '-')) : '-'
          }
        })
      })
      console.log('table copied to clipboard')
      navigator.clipboard.writeText(transTable)
    },

    exportFileFunc() {
      //downloadStatisticsFile(this.dataCard.data[0].id,'EXCEL')
      // savedownload(this.$route.params.lang, this.dataCard.data[0].id, 'customExport.csv')
      exportFile(this.dataCard, this.internalPivotConfig, this.tableData)
    },
    tooltipFunction(d, key, self) {
      // Se ha ido a "@/utils/chart" para poder usarlo tambien en los injecteds
      return sdvTooltipFunction(
        d,
        key,
        self,
        this.dataCard,
        this.internalPivotConfig,
        this.dimensionMetas,
        this.dimensionOptions,
        this.flatDimensionsOptions
      )
    },
    showShareModal() {
      this.$modal.show('modal-share', { url: this.getShareUrl(), embed: true, dataTitle: this.dataCard.title })
    },
    modalOpenApi() {
      this.$modal.show('modal-statistics-api')
    },
    modalCloseApi() {
      this.$modal.hide('modal-statistics-api')
    },
    swapModelCountry() {
      return
    },

    drillDown(row) {
      return row
    },
    onCellDblclick() {},
    onSaveInsight(insight) {
      let newInsights = this.internalPivotConfig.insights.filter(ins => !coordsEqual(ins, insight))
      newInsights.push(insight)
      this.internalPivotConfig.insights = newInsights
    },
    onDeleteInsight(insight) {
      let newInsights = this.internalPivotConfig.insights.filter(ins => !coordsEqual(ins, insight))
      this.internalPivotConfig.insights = newInsights
    },
    debouncedChangeEvent: debounce(function () {
      this.emitChangeEvent()
    }, 200),
    emitChangeEvent() {
      let config = JSON.parse(JSON.stringify(this._internalPivotConfig))
      console.log('emiting config')
      // console.log('config:', JSON.stringify(config, null, 4))
      this.updateQuery()
      if (!config) {
        this.setDefaultConfigs()
      }
      this.$emit('change-config', config ? config : this.defaultPivotConfig)
    },
    onQueryChange(q) {
      let config
      let defaultConfig = createDefaultPivotConfig(this.dimensions, this.currentChart)
      if (q.diff) {
        config = applyDiffs(defaultConfig, stringToFilters(q.diff),this.dimensions)
        // console.log('CHANGED QUERY')
        this.internalPivotConfig = { ...this.internalPivotConfig, ...config }
        console.log(this.internalPivotConfig)
      }
      if (q.ccfg) {
        let chartConfig = stringToFilters(q.ccfg)
        // chartConfig = chartConfig.reduce((cfg, c) => {
        //   cfg = { ...cfg, ...c }
        //   return cfg
        // }, {})
        if (chartConfig?.targetChart === 'map') this.internalMapConfig = { ...chartConfig.config }
        else this.internalChartConfig = { ...chartConfig.config }
      }
      if (!q.diff && !q.ccfg) {
        // cuando cambiamos de "chart" el StatisticsChart pone el "diff=null" para que se recalcule AQUI
        this.updateQuery()
      }
    },
    getConfigQuery() {
      let diff = getDiffs(this.defaultPivotConfig, this.internalPivotConfig, this.dimensions)
      let ccfg =
        this.internalPivotConfig.targetChart !== 'map'
          ? { config: this.$refs?.chart?.getNonDefaultConfig() }
          : { config: this.internalMapConfig }
      ccfg.targetChart = this.internalPivotConfig.targetChart 
      let diffStr = diff && filtersToString(diff)
      let ccfgStr = ccfg && filtersToString(ccfg)
      return { diffStr, ccfgStr }
    },
    updateQuery() {
      if (LIVE_QUERY_CONFIG) {
        let { diffStr, ccfgStr } = this.getConfigQuery()
        if (
          (diffStr && diffStr !== this.$route.query.diff) ||
          (ccfgStr && ccfgStr !== this.$route.query.ccfg)
        ) {
          // console.log(`pushing DIFF`, this.internalPivotConfig.targetChart)
          this.$router.replace({ query: { ...this.$route.query, diff: diffStr, ccfg: ccfgStr } })
        }
      }
    },

    setDefaultConfigs() {
      if (!this.defaultPivotConfig) {
        this.defaultPivotConfig = createDefaultPivotConfig(this.dimensions, this.currentChart)
      }

      let tmp = createDefaultPivotConfig(
        this.dimensions,
        this.currentChart,
        this._internalPivotConfig,
        this.flatDimensionsOptions
      )
      this._internalPivotConfig = tmp
      this.emitChangeEvent()
      console.log('Setting default config', this.internalPivotConfig)
    },

    getShareUrl() {
      let { diffStr, ccfgStr } = this.getConfigQuery()
      let route
      if (ccfgStr) {
        route = this.$router.resolve({
          ...this.$route,
          query: { ...this.$route.query, diff: diffStr, ccfg: ccfgStr },
        })
      } else {
        route = this.$router.resolve({
          ...this.$route,
          query: { ...this.$route.query, diff: diffStr },
        })
      }

      const absoluteURL = new URL(route.href, window.location.origin).href
      return absoluteURL
    },
    queueChangeEvent() {
      // ponemos un "debounce" para el "calculating" de 200ms
      clearTimeout(this.calculatingTimer)
      this.calculatingTimer = setTimeout(() => {
        if (this.status === 'precalculating') this.status = 'calculating'
      }, 250)
      this.status = 'precalculating'
      this.debouncedChangeEvent()
    },
    resetToDefault() {
      let q = { ...this.$route.query}
      delete q.diff
      delete q.ccfg
      this.internalChartConfig = null
      this.internalPivotConfig = JSON.parse(JSON.stringify(this.defaultPivotConfig))
      this.$refs?.table?.resetAllCols()
      this.$router.push({ query: q })
    },
  },
}
</script>
<style lang="stylus" scoped>

.pivot-wrapper
  width: 100%

.pivot-component
  display: flex
  flex: 1 1 0%
  height: 100%
  width: 100%

  .left
    display: flex
    flex: 1 1 0%
    flex-direction: column
    overflow: hidden
    position: relative

    .mobile &
      padding: 0

    &.left-table
      height: 600px // UN POCO ARBITRARIO ESTE 600px

    &.left-chart
      height: 600px // UN POCO ARBITRARIO ESTE 600px

      .mobile &
        height: 60vh

    .top
      align-items: center
      display: flex
      padding: vw(10px) vw(25px)
      z-index: 3

      .mobile &
        flex-wrap: wrap
        margin-bottom: vw(40px)
        padding: 0
        padding-left: vw(20px)
        padding-right: vw(20px)
        // padding: vw(10px) vw(10px) vw(10px) vw(25px)
        width: 100%

    .map-container
      .map
        height: 550px
        margin-bottom: vw(35px)
        margin-top: vw(5px)

        .mobile &
          height: 60vh
          margin: 0

  .right
    flex: 0 0 vw(280px)

.global-filter
  flex: 1 1 0%

  .mobile &
    flex: none
    left: 100%
    padding: vw(20px) vw(20px) 0
    position: sticky
    top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(100px))
    width: min-content
    z-index: 4

    .global-filter-container
      align-items: flex-end
      flex-direction: column
      padding: 0

.global-filter-hack
  height: vw(16px)
  margin-bottom: vw(5px)

.global-filter-container
  align-items: center
  display: flex
  gap: vw(10px)
  justify-content: flex-end

.search-count-container
  align-items: center
  display: flex
  gap: vw(5px)
  margin-right: vw(10px)

.search-count-icon
  m-icon("eye-gray", 20)

.search-count-text
  m-font-size(15, 19)
  color: $bcn-other-grey

.fav-button
  align-items: center
  border: 1px solid $grey-grey
  border-radius: 4px
  cursor: pointer
  display: flex
  padding: vw(5px) vw(15px)

  &:hover
    background-color: $light-grey

  &.fav-checked
    background-color: $grafics-yellow !important

  span
    m-font-size(14, 20)
    font-weight: 400

.copy-wrapper
  border: 1px solid $grey-accessibility
  border-radius: 50%
  cursor: pointer
  padding: vw(5px)
  position: relative

  .mobile &
    padding: vw(8px)

  .absolute-wrap
    background-color: #fff
    border: 1px solid $grey
    border-radius: 6px
    display: flex
    flex-direction: column
    gap: vw(3px)
    padding: vw(10px) 0
    position: absolute
    right: 0
    top: calc(100% + 1px)
    width: max-content
    z-index: 2

    .op-wrap
      align-items: center
      cursor: pointer
      display: flex
      gap: vw(6px)
      padding: vw(7px) vw(10px)

      &:hover
        background-color: $bcn-very-light-grey

      span
        m-font-size(14, 18)
        font-weight: 400

      .icon-download
        m-icon("arrow-back", 18, #fff, false)
        transform: rotate(-90deg)

      .icon-share
        m-icon("share", 18, #fff, false)

.icon-copy
  m-icon("copy", 18, #fff, false)

.icon-api
  m-icon("api", 18, #fff, false)

.options-button-icon
  m-icon("more-op", 18, black, true)

.input-wrapper
  align-items: center
  display: flex
  position: relative

  .mobile &
    flex: 1 1 0%

  input
    m-font-size(16, 20)
    background-color: $bcn-grey
    border: none
    border-radius: 5px
    padding: vw(5px) vw(28px) vw(5px) vw(30px)

    .mobile &
      width: 100%

  .search-button-icon
    m-icon("search-black", 22)
    margin-left: vw(5px)
    position: absolute
    
  .close-button-icon
    m-icon("close", 22)
    margin-left: "calc(%s - %s)" % (100% vw(25px))
    position: absolute
    cursor: pointer

.icons
  align-items: center
  display: flex
  gap: vw(10px)

  .icon
    cursor: pointer

    &.disabled
      m-icon("refresh-grey-fill", 32, $bcn-other-grey, false)
      cursor: not-allowed

    $colors = "black" "white" "grey"
    $icons = "edit" "refresh" "download" "share"

    for $color in $colors
      for $icon in $icons
        &.{$color}-fill
          &.{$icon}
            m-icon($icon + "-" + $color + "-fill", 32, $color, false)

            .mobile &
              m-icon($icon + "-" + $color + "-fill", 38, $color, false)

.more-toggle
  m-font-size(10, 16)
  align-items: center
  border: 1px solid transparent
  color: $seat-orange
  cursor: pointer
  display: flex
  padding: vw(5px)

  &:hover
    border-color: $seat-orange

  &.enabled
    background: $seat-orange
    color: #fff

  .icon
    margin-right: vw(5px)

.swap-button
  align-items: center
  border: 1px solid transparent
  cursor: pointer
  display: flex
  padding: vw(5px)

  &:hover
    border-color: $seat-orange

.swap-button-icon
  margin-right: vw(5px)

.swap-button-text
  m-font-size(10, 16)
  color: $seat-orange
  font-weight: 500

.bottom
  // ESTO "seguro" para el chart+slider (no se con el table como de mal le va...)
  display: flex
  flex: 1 1 0%
  // 
  flex-direction: column
  overflow: hidden
  position: relative

  // .mobile &
  // flex: 0 0 100vw

  // &.table-container
  // margin: 0 auto
  .mobile-edit
    bottom: 40px
    justify-content: flex-end
    margin-right: 20px
    position: absolute
    right: 0
    z-index: 2

  .table
    height: 100%
    // position: absolute
    width: 100%

    .table-wrapper
      height: 100%
      width: 100%

  .table-overlay
    background-color: rgba($bcn-very-light-grey, 0.7)
    height: 100%
    min-height: 200px
    position: absolute
    width: 100%
    z-index: 1

    &.cover
      background-color: #fff

    .content
      left: 50%
      position: absolute
      top: 30%
      transform: translate(-50%, -50%)

.more-toggle-mobile
  background: $seat-orange
  border-radius: 50%
  bottom: vw(20px)
  box-shadow: 5px 5px 10px rgba(#000, 0.3)
  display: flex
  height: vw(48px)
  position: fixed
  right: vw(20px)
  width: vw(48px)
  z-index: 5

  .icon
    margin: auto

.swap-button-mobile
  background: #fff
  border: solid 1px $seat-orange
  border-radius: 50%
  bottom: vw(20px)
  box-shadow: 5px 5px 10px rgba(#000, 0.3)
  display: flex
  height: vw(48px)
  position: fixed
  right: vw(88px)
  width: vw(48px)
  z-index: 5

  .icon
    margin: auto

.full-filters
  background-color: #fff
  filter: drop-shadow(0 4px 80px rgba(#000, 0.05))
  position: relative

.config-tabs
  align-items: center
  display: flex
  gap: vw(10px)

  .config-tab
    m-font-size(16, 25)
    border-bottom: solid 1px $bcn-grey
    cursor: pointer
    flex: 1 1 0%
    padding: vw(10px)
    position: relative
    text-align: center

    &:before
      background-color: $grey-dark
      bottom: 0
      content: ""
      display: none
      height: 3px
      left: 0
      position: absolute
      width: 100%

    &:hover
      &:before
        display: block

    &.active
      color: $corporate_color
      cursor: default

      &:before
        background-color: $corporate_color
        display: block

  .dropdown
    &:not(:last-child)
      border-bottom: 1px solid $neutral-gray-4

.full-filters-header
  align-items: center
  display: flex
  justify-content: space-between
  padding: vw(25px) vw(20px) vw(10px)

.full-filters-title
  m-font-size(16, 25)
  display: flex

.full-filters-close-icon
  m-icon("close-blue", 20)
  cursor: pointer

.more-info-container
  display: flex
  flex-direction: column
  gap: vw(10px)
  margin-top: vw(10px)
  padding: 0 vw(20px)

  .mobile-button-wrapper
    align-items: center
    border: 1px solid lightgray
    border-radius: 2px
    display: flex
    gap: vw(10px)
    padding: vw(10px) vw(15px)
    
    &.fav-color
      background-color: $grafics-yellow

    .icon
      cursor: pointer

    .download
      m-icon("download-black", 15)

    .share
      m-icon("share", 15)
      
    .favourite
      m-icon("star-active", 15)

    span
      m-font-size(14, 20)
      color: $grey-dark

  .note-container
    display: flex
    padding: vw(10px) 0 vw(15px)

    .note-text
      m-font-size(14, 20)

.white-bckgrd
  background-color: white
  
.icon-loader
  m-icon("loader", 20)
  margin-left: vw(5px)
  animation: rotate 1s infinite linear

@keyframes rotate
  from
    transform: rotate(0)

  to
    transform: rotate(360deg)
</style>
